import { useState } from 'react';
import { useDrawer } from '../../../shared/drawer';
import { PageBody } from '../../../elements/page-body';
import { Table } from '../../../elements/table';
import { TiposMantenimientoForm } from './tipos-mantenimiento-form';


export const TiposMantenimiento = () => {
    const { open, close } = useDrawer();
    const [refresh, setRefresh] = useState<string | null>(null);




    const handleNewAction = () => {
        open('common.label.nuevo-tipo-mantenimiento', <TiposMantenimientoForm close={handleClose} />);
    };

    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };


    return (
        <PageBody
            newAction={handleNewAction}
            title={'common.label.tipos-mantenimiento'}
            newActionTitle={'common.label.nuevo-tipo-mantenimiento'}
        >
            <>
                <Table
                    path="/fleet/maintenance-types/"
                    deletePath="/fleet/maintenance-types/"
                    callBeforeDrawerClosed={handleClose}
                    Form={TiposMantenimientoForm}
                    withPagination
                    refresh={refresh}
                    headers={[
                        {
                            key: 'name',
                            label: 'common.form-label.name'
                        },
                        {
                            key: 'description',
                            label: 'common.form-label.descripcion'
                        },
                        {
                            key: 'is_ordinary',
                            type: 'boolean',
                            label: 'common.label.mantenimiento-ordinario'
                        }
                    ]}
                />
            </>
        </PageBody>
    );
};